import React from 'react';
import { Table as MuiTable, TableContainer } from '@mui/material';
import classnames from 'classnames';
import { makeStyles } from 'tss-react/mui';

import TableHead from './TableHead';
import TableBody from './TableBody';
import { ITable, TypeSize } from './interface';

export const useStyles = makeStyles()((theme) => ({
  tableContainer: {
    minWidth: 650,
    // marginBottom: theme.spacing(15),
    color: theme.palette.text.primary,

    '& .MuiTableCell-body': {
      fontSize: 14,
    },
  },
  table: {
    minWidth: '100%',
    width: 'max-content',
  },
}));

const Table = ({
  headCells,
  rowsData,
  columns,
  onClickRow = (a?: number | string) => {},
  size = 'small',
  styles = {},
  colgroup = <></>,
  stickyHeader = false,
}: ITable) => {
  const { classes } = useStyles();
  return (
    <TableContainer
      className={classnames(classes.tableContainer, styles?.tableContainer)}>
      <MuiTable
        size={size}
        className={classes.table}
        stickyHeader={stickyHeader}>
        {colgroup}
        <TableHead
          styles={styles}
          headCells={headCells}
          onClickAllRows={onClickRow}
        />
        <TableBody
          onClickRow={onClickRow}
          rowsData={rowsData}
          columns={columns}
          styles={styles}
        />
      </MuiTable>
    </TableContainer>
  );
};

export default Table;
